module.exports = __webpack_public_path__ + "img/agent.9e7bdc78.png";